import React, { useState } from 'react';
import './Biography.css';

const tabs = [
  {
    id: 'biography',
    title: 'BIOGRAPHY OF GURU',
    active: true,
    description: `Sree Narayana Guru was born at 6-15 a.m on August 28, 1855 (1031 chingom 14 / M.E) in "Vayalvaram Veedu" at Chempazhanthy, a village near Trivandrum in a community which possessed no rights and privileges and was totally neglected for far centuries. The then society was laden with many evils like caste system,`,
  },
  { id: 'sharadha', title: 'SHARADHA MUTT', active: false, description: `The Goddess of knowledge and wisdom, Mother Goddess Sri Sharadamba was installed at Sivagiri Saradamutt on 1st May 1912. Sri Sharadamba, the supreme patron goddess of all fine arts and education, is seated on a fullblown lotus flower.` },
  { id: 'sivagiri', title: 'HISTORY OF SIVAGIRI PILGRIMAGE', active: false, description: `At the beginning of 1928 while the Sree Narayana Guru was camping at Nagampadam temple at Kottayam, a couple of his ardent disciples hesitantly mooted the idea of "Pilgrimage to Sivagiri". Guru explained that the aim of Theerthadana must be for the creation of comprehensive knowledge among the people for their overall development and prosperity.` },
];

const Biography = ({ onViewMore, onViewMoreSharadha, onViewMoreSivagiri }) => {
  const [activeTab, setActiveTab] = useState('biography');

  return (
    <section className="biography" id="about">
      <div className="biography-container">
        <div className="biography-image">
          <img
            src="/Sndp/567575675756-scaled.jpg"
            alt="Sree Narayana Guru"
          />
        </div>

        <div className="biography-tabs">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className={`biography-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <h3 className={`tab-title ${activeTab === tab.id ? 'active' : ''}`}>
                {tab.title}
              </h3>

              {activeTab === tab.id && tab.description && (
                <div className="tab-content">
                  <p className="tab-description">{tab.description}</p>
                  <button
                    className="tab-view-more"
                    onClick={tab.id === 'sharadha' ? onViewMoreSharadha : tab.id === 'sivagiri' ? onViewMoreSivagiri : onViewMore}
                  >
                    VIEW MORE
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Biography;
